import { render } from "./digitize-types-list.vue?vue&type=template&id=458401c4"
import script from "./digitize-types-list.vue?vue&type=script&lang=js"
export * from "./digitize-types-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__